export default __webpack_public_path__ + "graphics/experience-1024.79ed9297.jpg";